import { Divider as MuiDivider } from "@mui/material";
import Box from "@mui/material/Box";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
import { LeftSidebar as NavFrame } from "layout-blueprints";
import { getByUuid as getMeterByUuid } from "../../modules/meter/api/actions";
import MeterDetailCard from "../../modules/meter/components/DetailCard";
import MeterReadForm from "../../modules/meter/components/meterReadForm";
import MeterHistory from "modules/meter/components/MeterHistory";


const Divider = styled(MuiDivider)(spacing);
const IndividualMeterPage = (props) => {
  const params = useParams();
  const meterUuid = params.uuid;
  useEffect(() => {
    props.getMeterByUuid(meterUuid);
    document.title = "Ubil+ Meter";
  }, []);

  return (
    <NavFrame page={"IndividualMeterPage"}>
      <StandardHeader title="Meter" />
      <Divider className="mb-3 mt-3" />
      <Box sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box>
            <MeterDetailCard />
            <br></br>
            <MeterReadForm />
          </Box>
          <Box>
            <MeterHistory/>
          </Box>
        </Box>
      </Box>
    </NavFrame>
  );
};

IndividualMeterPage.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  meter: PropTypes.object.isRequired,
  getMeterByUuid: PropTypes.func.isRequired,
};

// Component State
function IndividualMeterPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    meter: state.meter,
  };
}

export default connect(IndividualMeterPageState, { getMeterByUuid })(
  IndividualMeterPage
);
